import { request } from "@weapp/utils";
import { getTokenStorage, mainHost, encryptRsa, getCookie, passportHost } from '../../utils';
import { publicUrlapi } from "../../constants";

const FORGET_PREFIX = `${passportHost()}${publicUrlapi}/papi/passport/password`
/**
 * 校验账号
 * @param params {account: string}
 */
export const checkAccount = (params: any) => {
    return request({
        url: FORGET_PREFIX + "/validateAccount",
        params
    });
};
/**
 * 获取验证码
 * @param params {account: string}
 */
export const sendMobileCode = (params: any) => {
    if (window.e_customPageData?.tenantKey) {
        params.tenantKey = window.e_customPageData.tenantKey;
    }
    return request({
        url: FORGET_PREFIX + "/sendMobileCode",
        method: "POST",
        headers: {
            "langType": getCookie('langType') || 'zh_CN'
        },
        params
    });
};
/**
 * APP/H5获取验证码
 */
export const sendAppMobileCode = () => {
    return request({
        url: FORGET_PREFIX + "/appSendValidCode?userIdToken=" + getTokenStorage(),
        headers: {
            "langType": getCookie('langType') || 'zh_CN'
        },
        method: "GET"
    });
};

/**
 * 发送邮件找回密码
 * @param params {account: string}
 */
export const sendEmailCode = (params: any) => {
    if (window.e_customPageData?.tenantKey) {
        params.tenantKey = window.e_customPageData.tenantKey;
    }
    return request({
        url: FORGET_PREFIX + "/sendEmail",
        method: "POST",
        headers: {
            "langType": getCookie('langType') || 'zh_CN'
        },
        params
    });
};
/**
 * 获取验证码Token
 * @param params {key: string}
 */
export const getTokenByEmail = (params: any) => {
    return request({
        url: FORGET_PREFIX + "/getTokenByEmail",
        method: "POST",
        params
    });
};
/**
 * 确认设置手机密码
 * @param params {code: string, password: string, passwordConfirm: string}
 */
export const changeByMobile = (params: any) => {
    // 暂时注释
    params = encryptRsa(params, 'password');
    params = encryptRsa(params, 'passwordCheck');
    if (sessionStorage.getItem('email_psw_customTenantKey')) {
        params.tenantKey = sessionStorage.getItem('email_psw_customTenantKey');
    } else if (window.e_customPageData?.tenantKey) {
        params.tenantKey = window.e_customPageData.tenantKey;
    }
    return request({
        url: FORGET_PREFIX + "/changeByMobile",
        method: "POST",
        params,     //TODO params传参先保留，兼容原来的接口，后期稳定之后去掉
        data: params,   //接口传参改造
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
            "langType": getCookie('langType') || 'zh_CN'
        }
    });
};
/**
 * 确认设置邮箱密码
 * @param params {account: string}
 */
export const changeByEmail = (params: any) => {
    // 暂时注释
    params = encryptRsa(params, 'password');
    params = encryptRsa(params, 'passwordCheck');
    if (sessionStorage.getItem('email_psw_customTenantKey')) {
        params.tenantKey = sessionStorage.getItem('email_psw_customTenantKey');
    } else if (window.e_customPageData?.tenantKey) {
        params.tenantKey = window.e_customPageData.tenantKey;
    }
    return request({
        url: FORGET_PREFIX + "/changeByEmail",
        method: "POST",
        params, //TODO params传参先保留，兼容原来的接口，后期稳定之后去掉
        data: params,
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
            "langType": getCookie('langType') || 'zh_CN'
        }
    });
};
/**
 * 移动端发送验证码
 * @param params {account: string}
 */
export const appSendValidCode = (params: any) => {
    if (window.e_customPageData?.tenantKey) {
        params.tenantKey = window.e_customPageData.tenantKey;
    }
    return request({
        url: FORGET_PREFIX + "/appSendValidCode",
        method: "POST",
        headers: {
            "langType": getCookie('langType') || 'zh_CN'
        },
        params
    });
};
/**
 * app/h5确认设置邮箱密码
 * @param params {account: string}
 */
export const appChangeByEmail = (params: any) => {
    // 暂时注释
    params = encryptRsa(params, 'password');
    params = encryptRsa(params, 'passwordCheck');
    if (sessionStorage.getItem('email_psw_customTenantKey')) {
        params.tenantKey = sessionStorage.getItem('email_psw_customTenantKey');
    } else if (window.e_customPageData?.tenantKey) {
        params.tenantKey = window.e_customPageData.tenantKey;
    }

    return request({
        url: FORGET_PREFIX + "/changeByEmailCode",
        method: "POST",
        params, //TODO params传参先保留，兼容原来的接口，后期稳定之后去掉
        data: params,
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
            "langType": getCookie('langType') || 'zh_CN'
        }
    });
};

/**
 * 查询用户密保信息
 */
export const qryUserSecrecy = (account: string) => {
    let params = { type: 1, account } as any
    if (window.e_customPageData?.tenantKey) {
        params.tenantKey = window.e_customPageData.tenantKey;
    }
    return request({
        url: FORGET_PREFIX + "/qryUserSecrecy",
        params
    });
};

/**
 * 验证用户密保信息
 */
export const validSecrecy = (account: string, data: any) => {
    if (window.e_customPageData?.tenantKey) {
        data.tenantKey = window.e_customPageData.tenantKey;
    }
    return request({
        url: FORGET_PREFIX + "/vaildSecrecy" + '?account=' + account,
        method: 'POST',
        data
    });
};

/**
 * 用户密保信息修改密码
 */
export const changeBySecrecy = (data: any) => {
    if (window.e_customPageData?.tenantKey) {
        data.tenantKey = window.e_customPageData.tenantKey;
    }
    // 暂时注释
    data = encryptRsa(data, 'password');
    data = encryptRsa(data, 'passwordCheck');
    return request({
        url: FORGET_PREFIX + "/changeBySecrecy",
        params: data,   //TODO params传参先保留，兼容原来的接口，后期稳定之后去掉
        data: data,
        method: "POST",
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
            "langType": getCookie('langType') || 'zh_CN'
        }
    });
};
/**
 * 查询用户是否开启密保
 */
export const querySecrecyStatus = (account: string) => {
    return request({
        url: FORGET_PREFIX + "/qrySecrecyStatus" + '?account=' + account
    });
};